import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { ListenerPayload, OptimizelyDecision } from '@optimizely/optimizely-sdk'

export type OptimizelyDecisionInfo = {
  decisionInfo: OptimizelyDecision
} & ListenerPayload

export function DDInstrumentOFXDecision(decision: OptimizelyDecisionInfo) {
  const { flagKey, variationKey } = decision.decisionInfo

  try {
    datadogRum.addFeatureFlagEvaluation(flagKey, variationKey)
    datadogRum.setUserProperty('OFXClientID', decision.userId)
    datadogLogs.setUserProperty('OFXClientID', decision.userId)
  } catch (err) {
    datadogLogs.logger.warn(`Unable to instrument Optimizely FX decision for flag '${flagKey}'`, {
      err,
    })
  }
}
